import { render, staticRenderFns } from "./PasswordRecover.vue?vue&type=template&id=20b209d4&"
import script from "./PasswordRecover.vue?vue&type=script&lang=js&"
export * from "./PasswordRecover.vue?vue&type=script&lang=js&"
import style0 from "./PasswordRecover.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports